export default __webpack_public_path__ + "static/media/globe.857354e8.svg";